import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ProjectCard from "./CertifyCards";

import EthicalHacking from "../../Assets/Ethical Hacking.jpg";
import CProgramming from "../../Assets/Problem Solving Through Programming In C.jpg";
import gfgReact from "../../Assets/React_GFG.png";
import problemSolving from "../../Assets/problem solving.png";
import BackendPW from "../../Assets/BackendPW.png";
import Java from "../../Assets/javaProgramming.png";
import PythonNptel from "../../Assets/python.jpg";
import PythonHackkerrank from "../../Assets/pythonHackkerank.png";
import gfg160 from "../../Assets/gfg-160.png"

// Create an array of certificate objects
const certificateData = [
  {
    imgPath:gfgReact , title:"React JS Course Online - React JS Certification Course"
  },
  { imgPath: gfg160, title: "GFG 160 Days DSA Practice challange certificate" },
  { imgPath: BackendPW, title: "Backend Development PWSkills" },
  { imgPath: PythonHackkerrank, title: "Python HackerRank" },
  { imgPath: problemSolving, title: "Problem Solving" },
  { imgPath: Java, title: "Java Nptel" },
  { imgPath: EthicalHacking, title: "Ethical Hacking NPTEL" },
  { imgPath: PythonNptel, title: "Python(DSA) NPTEL" },
  { imgPath: CProgramming, title: "Problem Solving in C NPTEL" },
];

function Certificate() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Certificates </strong>
        </h1>
       
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {certificateData.map((cert, index) => (
            <Col key={index} md={4} className="project-card">
              <ProjectCard
                imgPath={cert.imgPath}
                isBlog={false}
                title={cert.title}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Certificate;

// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// // import certificateCards from "./certificateCardss";

// import Particle from "../Particle";
// // import ProjectCard from "./ProjectCards";
// import ProjectCard from "./CertifyCards";
// // import CertifyCards from "./CertifyCards";
// import EthicalHacking from "../../Assets/Ethical Hacking.jpg";
// import CProgramming from "../../Assets/Problem Solving Through Programming In C.jpg";
// import problemSolving from "../../Assets/problem solving.png";
// import BackendPW from "../../Assets/BackendPW.png"
// import Java from "../../Assets/javaProgramming.png";
// import PythonNptel from "../../Assets/python.jpg";
// import PythonHackkerrank from "../../Assets/pythonHackkerank.png";

// function Certificate() {
//   return (
//     <Container fluid className="project-section">
//       <Particle />
//       <Container>
//         <h1 className="project-heading">
//           My Recent <strong className="purple">Certificates </strong>
//         </h1>
//         <p style={{ color: "white" }}>
//           Here are a few projects I've worked on recently.
//         </p>
//         <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
//             <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={BackendPW}
//               isBlog={false}
//               title="Backend Development PWSkills"
//             />
//           </Col>
//             <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={PythonHackkerrank}
//               isBlog={false}
//               title="Python HackerRank"
//             />
//           </Col>
          

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={problemSolving}
//               isBlog={false}
//               title="Problem Solving"
//             />
//           </Col>
//           <Col md={4} className="project-card">
//             <ProjectCard imgPath={Java} isBlog={false} title="Java Nptel" />
//           </Col>

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={EthicalHacking}
//               isBlog={false}
//               title="Ethical Hacking NPTEL"
//             />
//           </Col>

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={PythonNptel}
//               isBlog={false}
//               title="Python(DSA) NPTEL"
//             />
//           </Col>

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={CProgramming}
//               isBlog={false}
//               title="Problem Solving in C NPTEL"
//             />
//           </Col>
//         </Row>
//       </Container>
//     </Container>
//   );
// }

// export default Certificate;
